import Tooltip from "@mui/material/Tooltip";
import { AUDIT_TOKENS } from "../../theme/auditTokens";

/** The "—" placeholder for cells without data, optionally explaining why. */
export function EmptyValue({ title }: { title?: string }) {
  const dash = (
    <span style={{ color: AUDIT_TOKENS.empty }} aria-label={title}>
      {"—"}
    </span>
  );
  return title ? <Tooltip title={title}>{dash}</Tooltip> : dash;
}
